//core
import React from 'react';
import {useTranslation} from "react-i18next";
import arePropsEqual from "react-fast-compare";
import {Chip} from "@mui/material";

//theme
import {Theme} from "@mui/material/styles/createTheme";
import {useTheme} from "@mui/styles";
import {
  red,
  green,
  blueGrey,
} from "@mui/material/colors";


interface IStatus {
  value: string;
}

const AgentStatus = ({value}: IStatus) => {
  const theme: Theme = useTheme();
  const {t} = useTranslation();

  return (
    <>
      {value === "active" && <Chip size="small" label={t("common.components.status.active")} color="primary"
                                   sx={{backgroundColor: green[500]}}/>}
      {value === "inactive" && <Chip size="small" label={t("common.components.status.inactive")} color="primary"
                                   sx={{backgroundColor: blueGrey[500]}}/>}
      {value === "blocked" && <Chip size="small" label={t("common.components.status.blocked")} color="primary"
                                     sx={{backgroundColor: red[500]}}/>}
    </>
  );
};

export default React.memo(AgentStatus, arePropsEqual)
